<script lang="ts">
	import { Button, ButtonV2, Icon, Text, type TextPropsTypes } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let title: string;
	export let description: string;
	export let btnText: string = null;
	export let onClick: () => void = null;
	export let loading = false; //Pako - added loading because sometimes we needed it
	export let withoutMargin = false;
	export let type: 'modal' | 'drawer' | 'page' = 'page';
	export let icon: string | null = null

	let titleStyleType: TextPropsTypes['styleType'] = 'h1';
	let descriptionStyleType: TextPropsTypes['styleType'] = 'body';

	$: if (type === 'modal' || type === 'drawer') {
		titleStyleType = 'body';
		descriptionStyleType = 'body-small';
	}
</script>

<div class="text-center">
	{#if icon}
		<Icon {icon} size="l" class="mb-m" />
	{/if}
	<Text
		class={classMap({
			'mb-s text-center': true,
			'text-bold': type === 'modal' || type === 'drawer',
		})}
		styleType={titleStyleType}
	>
		{title}
	</Text>
	<Text
		class={classMap({
			'mb-m': btnText,
			'text-center': true,
			'text-color-muted': true,
		})}
		styleType={descriptionStyleType}>{description}</Text
	>

	{#if btnText}
		{#if $showNewLayout}
			<ButtonV2
				variant="primary"
				class={!withoutMargin ? 'mb-m' : ''}
				{loading}
				on:click={() => {
					onClick();
				}}
			>
				{btnText}
			</ButtonV2>
		{:else}
			<Button
				size={type === 'drawer' || type === 'modal' ? 'm' : 'l'}
				class={!withoutMargin ? 'mb-m' : ''}
				{loading}
				on:click={() => {
					onClick();
				}}
			>
				{btnText}
			</Button>
		{/if}
	{/if}
</div>
